// ═══════════════════════════════════════════════════════════════════════════════
// Keep admin portal pages out of search indexes
// ═══════════════════════════════════════════════════════════════════════════════

import { useEffect, type ReactNode } from 'react';

const ROBOTS_META_ATTR = 'data-admin-portal-robots';

type AdminPortalNoIndexProps = {
  children: ReactNode;
};

export const AdminPortalNoIndex = ({ children }: AdminPortalNoIndexProps) => {
  useEffect(() => {
    const existing = document.querySelector(`meta[${ROBOTS_META_ATTR}="true"]`);
    if (existing) {
      return () => {
        existing.remove();
      };
    }

    const meta = document.createElement('meta');
    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex, nofollow');
    meta.setAttribute(ROBOTS_META_ATTR, 'true');
    document.head.appendChild(meta);

    return () => {
      meta.remove();
    };
  }, []);

  return <>{children}</>;
};
